interface SuggestionCardsProps {
  onSelectPrompt: (promptText: string) => void;
}

const SUGGESTIONS = [
  {
    title: 'Instant Extraction',
    desc: 'Extract vendor, dates, totals & payment details from an uploaded invoice.',
    prompt: 'Extract all header metadata, vendor info, dates, and total amounts from this invoice.',
    icon: (
      <svg className="w-5 h-5 text-brand-vib" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
  },
  {
    title: 'Tax & VAT Audit',
    desc: 'Verify tax rates, calculate tax breakdown and flag calculation mismatches.',
    prompt: 'Audit tax rates and flag any discrepancies between line items and overall invoice tax.',
    icon: (
      <svg className="w-5 h-5 text-brand-green" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    title: 'Line Item Breakdown',
    desc: 'Parse complex tabular line items with quantities, units, and line totals.',
    prompt: 'Extract all table line items, descriptions, unit prices, and quantities into a structured list.',
    icon: (
      <svg className="w-5 h-5 text-brand-light" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
      </svg>
    ),
  },
  {
    title: 'Anomaly & Duplicate Check',
    desc: 'Scan for irregular pricing trends, potential duplicate invoices, or unusual terms.',
    prompt: 'Analyze this invoice for suspicious charges, unusual terms, or duplicate billing risks.',
    icon: (
      <svg className="w-5 h-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    ),
  },
];

export default function SuggestionCards({ onSelectPrompt }: SuggestionCardsProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5 mb-6">
      {SUGGESTIONS.map((item, idx) => (
        <button
          key={idx}
          type="button"
          onClick={() => onSelectPrompt(item.prompt)}
          className="group text-left p-4 rounded-2xl bg-white dark:bg-boxdark border border-brand-line dark:border-strokedark hover:border-brand-vib hover:shadow-card-hover transition-all duration-200 hover:-translate-y-0.5 flex items-start gap-3.5"
        >
          <div className="flex-shrink-0 p-2.5 rounded-xl bg-brand-bg dark:bg-strokedark/50 group-hover:bg-brand-blue-tint dark:group-hover:bg-brand-900/30 transition-colors">
            {item.icon}
          </div>
          <div>
            <h2 className="text-sm font-bold text-brand-navy dark:text-white group-hover:text-brand-vib transition-colors">
              {item.title}
            </h2>
            <p className="text-xs text-brand-muted dark:text-bodydark mt-0.5 line-clamp-2 leading-relaxed">
              {item.desc}
            </p>
          </div>
        </button>
      ))}
    </div>
  );
}
